var map = {
	"./COPD-home-monitoring.png": "023c",
	"./brand/brand-shape-1.png": "c943",
	"./brand/brand-shape-2.png": "e4cb",
	"./brand/brand-shape-3.png": "10e6",
	"./chrome.png": "5c1f",
	"./flags.png": "dd92",
	"./logo-bigpicture-poweredby-negative.svg": "e9eb",
	"./logo-bigpicture-poweredby.svg": "c5e6",
	"./logo-bigpicture-storybook.svg": "fe94",
	"./logo-bigpicture-text.svg": "15d7",
	"./map-pattern-a.png": "43a1",
	"./map-pattern-b.png": "1945",
	"./menicon/conjunctival-hyperemia-0.jpg": "bb2c",
	"./menicon/conjunctival-hyperemia-1.jpg": "1a03",
	"./menicon/conjunctival-hyperemia-2.jpg": "b922",
	"./menicon/conjunctival-hyperemia-3.jpg": "8132",
	"./menicon/conjunctival-hyperemia-4.jpg": "00ba",
	"./menicon/corneal-infiltrates-0.jpg": "2bba",
	"./menicon/corneal-infiltrates-1.jpg": "e51f",
	"./menicon/corneal-infiltrates-2.jpg": "3695",
	"./menicon/corneal-infiltrates-3.jpg": "ae89",
	"./menicon/corneal-infiltrates-4.jpg": "5741",
	"./menicon/corneal-neovascularisation-0.jpg": "1ad5",
	"./menicon/corneal-neovascularisation-1.jpg": "27d6",
	"./menicon/corneal-neovascularisation-2.jpg": "6e58",
	"./menicon/corneal-neovascularisation-3.jpg": "c311",
	"./menicon/corneal-neovascularisation-4.jpg": "16b5",
	"./menicon/corneal-staining-0.jpg": "1660",
	"./menicon/corneal-staining-1.jpg": "c7af",
	"./menicon/corneal-staining-2.jpg": "4abf",
	"./menicon/corneal-staining-3.jpg": "0b79",
	"./menicon/corneal-staining-4.jpg": "bc63",
	"./menicon/lens-collection-contact-lens-coverage.jpg": "3266",
	"./menicon/papillary-reaction-0.jpg": "5135",
	"./menicon/papillary-reaction-1.jpg": "79b8",
	"./menicon/papillary-reaction-2.jpg": "84e8",
	"./menicon/papillary-reaction-3.jpg": "9005",
	"./menicon/papillary-reaction-4.jpg": "d62c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43aa";